/**
 * Estimate fetch duration for lead count sync.
 * Mirrors backend: DELAY_BETWEEN_REQUESTS_MS=300, ESTIMATED_REQUEST_MS=6000
 * Conservative: SMSWiser can be slow for large lists (1–60s per request).
 * Formula: (N-1)*300 + N*6000 ms
 */

const DELAY_MS = 300;
const AVG_REQUEST_MS = 6000;

export function estimateFetchSeconds(leadCount: number): number {
  if (leadCount <= 0) return 0;
  const ms = (leadCount - 1) * DELAY_MS + leadCount * AVG_REQUEST_MS;
  return Math.ceil(ms / 1000);
}

export function formatEstimatedDuration(seconds: number): string {
  if (seconds < 60) return `~${seconds}s`;
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return secs > 0 ? `~${mins}m ${secs}s` : `~${mins}m`;
}
